import { Link } from "react-router-dom";
import React from "react";
import Seo from "../Seo";
import AsideContent2 from "../AsideContent2";
import GoToTop from "../GoToTop";
import SermonLinksList from "../assets/SermonLinksList";
// import Alar from "../assets/Thumbs/Alar60.jpg";


const MediaLinksPage = () => {
    function MediaListContent({resource}) {
  // const article = ResourcesList.find(article => article.objectName === articleId);
  // console.log('MC4', ResourcesList);
  //console.log('mc4', resource)
  // CHANGE Resources List to {resource.heading}
  
    return (
      <>
      <Seo title={resource.tabHeading} description={resource.metaDescription} keywords={resource.keywords} />
      <h2 className="sectionHeader">{resource.pageHeading}</h2>
      <p className="main marginClear paddingClear"><b>NOTE: </b>{resource.refresh}</p>
      <p className="main marginClear">{resource.description}</p>
      <div className="main">
        <div className="rListCont"><ul className="ulNone">
        {resource.linkList.map((listItem, li) => {
            // return (
            //     <li className="rList" key={li}><div  >
            //     <p className="citeTitle hasImgTag resources"><img className="imgTag" src={Alar} alt="" /> {listItem.firstName} {listItem.lastName}</p>
            //     {listItem.itemLinks.map((quoteList, i) => {
            //       return (
            //           <React.Fragment key={i}>
            //           <p className="rTitle"><a href={quoteList.sermonLink} title={quoteList.sermonTitle}  
            //           target="_blank" rel="noreferrer" className="rLinks"><b><span className="rListFrom">{quoteList.from}</span>{quoteList.sermonTitle}</b> <i className="rListFrom">{quoteList.sermonDate}</i></a></p>
            //           <p className="short"><b>{quoteList.sermonSubTitle}</b></p>
            //           <p className="short">Official Page: {quoteList.sermonChannel}</p>                     
            //           <hr />
            //           </React.Fragment>
            //         )
            //     })}
                
            //     </div></li>
                        
            // )
            return (
                <li className="rList" key={li}>
                  <div>
                <p className="citeTitle hasImgTag resources"><img className="imgTag" src={listItem.thumb} alt="" /> {listItem.firstName} {listItem.lastName}</p>
                <ul className="ulNone">
                {listItem.itemLinks.map((quoteList, i) => {
                  return (
                      <React.Fragment key={i}>
                      <li>  
                      <a href={quoteList.sermonLink} title={quoteList.sermonTitle}  
                      target="_blank" rel="noreferrer" className="rLinks"><div className="rLinksDiv">
                        <p className="rTitle"><b><span className="rListFrom">{quoteList.from}</span>{quoteList.sermonTitle}</b> <i className="rListFrom">{quoteList.sermonDate}</i></p>
                        <p className="short"><b>{quoteList.sermonSubTitle}</b></p>
                        <p className="short">Official Page: {quoteList.sermonChannel}</p>
                      </div></a>
                      </li>                     
                      <hr aria-hidden />
                      </React.Fragment>
                    )
                })}
                
              </ul></div></li>
                        
            )
        })}
        </ul></div>
        
        
      </div>
      </>
    );
  };
    
    
    
    return (
        <div className="content">
            <main>
                <MediaListContent resource={SermonLinksList} />
                <h2 className="back"><Link to="/MediaLinks" title="Back to Top" className="backLink link">- BACK To TOP -</Link></h2>
            </main>
            <aside>
                <AsideContent2 resource={SermonLinksList}/>
            </aside>
            <GoToTop />
  	    </div>
    );
};
export default MediaLinksPage;